import * as React from 'react';
import { Image } from '@cian/ui-kit';

import { NewbuildingFavoriteButton } from '../../../../../../../../containers/NewbuildingFavoriteButton';
import { NewbuildingDeleteButton } from '../../../../../../../../containers/NewbuildingDeleteButton';
import * as style from './Photo.css';

export interface IPhotoProps {
  id: number;
  imageUrl: string;
  name: string;
  isFavorite: boolean;
  gaLabel?: string;
}

export const Photo = ({ id, imageUrl, name, isFavorite, gaLabel }: IPhotoProps): React.JSX.Element => (
  <div className={style['container']}>
    <Image alt={name} borderRadius="16px" height={200} objectFit="cover" src={imageUrl} width="100%" />
    <div className={style['actions']}>
      <NewbuildingDeleteButton newbuildingId={id} size="M" />
      <NewbuildingFavoriteButton gaLabel={gaLabel} isFavorite={isFavorite} newbuildingId={id} />
    </div>
  </div>
);
